import { ajaxSend } from '../../../api/api';

export function getTimeline(payload: { requesterId: string }) {
  const { requesterId } = payload;
  const attributes = [
    'status',
    'created_at',
    'initial_channel',
    'id',
    'direction',
    'attributes',
  ];
  return ajaxSend({
    method: 'GET',
    path: `/v2/conversations/requester/${requesterId}?limit=500&attributes=${attributes.join(
      ',',
    )}`,
  });
}
